import React from 'react';
import ContractBody from './ContractBody';

interface Props {
    settings: any;
    coaches: any[];
    isSolo: boolean;
    /** false = Bestandskunde, true = Neukunde */
    isNewCustomer?: boolean;
}

/** Onboarding-Vorentwurf: PEOne Solo oder PEOne TeamPro */
const ContractPreviewInsider: React.FC<Props> = ({ settings, coaches, isSolo, isNewCustomer }) => (
    <ContractBody
        settings={settings}
        coaches={coaches}
        selectedPackage={isSolo ? 'solo' : 'teamPro'}
        variant="preview"
        includeHeader
        isNewCustomer={isNewCustomer}
    />
);

export default ContractPreviewInsider;
